'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = 'M320 8l0 200 56 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-144 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l72 0 0-189.2-69.7 20.9c-4.2 1.3-8.7-1.1-10-5.4s1.1-8.7 5.4-10l80-24c2.4-.7 5-.3 7.1 1.2S320 5.5 320 8zM96 296l0 200 56 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L8 512c-4.4 0-8-3.6-8-8s3.6-8 8-8l72 0 0-189.2-69.7 20.9c-4.2 1.3-8.7-1.1-10-5.4s1.1-8.7 5.4-10l80-24c2.4-.7 5-.3 7.1 1.2S96 293.5 96 296zm112 56c0-35.3 28.7-64 64-64l48 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-48 0c-35.3 0-64-28.7-64-64l0-96zm64-48c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0zM64 0l48 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM16 64l0 96c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L64 16C37.5 16 16 37.5 16 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;